export const initialState = {
  resourceList: [],
  resourceListLoading: false,
  resourceListError: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_LIST_RESOURCE":
      return {
        ...state,
        resourceList: [],
        resourceListLoading: true,
        resourceListError: null,
      };
    case "SUCCESS_LIST_RESOURCE":
      return {
        ...state,
        resourceList: action.payload.items,
        resourceListLoading: false,
      };
    case "ERROR_LIST_RESOURCE":
      return {
        ...state,
        resourceListError: action.error,
        resourceListLoading: false,
      };
    default:
      return state;
  }
};
